/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'
import React, { createContext, useContext, useEffect } from 'react'
import { GA4Event } from './types'

interface GTMContextValue {
    sendGA4Event: (event: string, data: GTMData) => void
}

type GTMData = Partial<GA4Event>

const GoogleTagManagerContext = createContext<GTMContextValue | undefined>(undefined)

export const GoogleTagManagerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const sendGA4Event = (event: string, data: GTMData) => {
        if (typeof window !== 'undefined' && window.dataLayer && Object.keys(data).length > 0) {
            window.dataLayer.push({ event, ...data })
        }
    }

    return <GoogleTagManagerContext.Provider value={{ sendGA4Event }}>{children}</GoogleTagManagerContext.Provider>
}

export const useGTM = (): GTMContextValue => {
    const context = useContext(GoogleTagManagerContext)
    if (!context) {
        throw new Error('useGTM must be used within a GTMProvider')
    }
    return context
}

export const GoogleTagManager: React.FC<{ event: string; gtmData: { [key: string]: any } }> = ({ event, gtmData }) => {
    const { sendGA4Event } = useGTM()
    useEffect(() => {
        sendGA4Event(event, gtmData)
    }, [])

    return null
}
